import {customElement, property} from "lit/decorators.js";
import {clickEventAlreadyHandledByChild, handleActivationKey} from "../../../common/utils/events";
import {UnLitElement} from "../../../common/elements";
import {Dialogs} from "./dialogs";
import {resolve} from "../../../container";
import {Resolution} from "../../../common/resolution";
import {BootstrapBreakpoint, bootstrapBreakpointByName} from "../../../common/resolutionConstants";
import type {Nullable} from "../../../bootstrap/common/types";

@customElement("eop-inline-dialog-content-link")
export class EopInlineDialogContentLink extends UnLitElement {

    @property({attribute: "dialog-id"})
    public dialogId: string;
    @property({attribute: "active-from-breakpoint", type: String})
    public activeFromBreakpoint: string = "xs";

    private activationBreakpoint: Nullable<BootstrapBreakpoint>;
    private active: boolean;

    public constructor(
        private dialogs: Dialogs = resolve(Dialogs),
        private resolution: Resolution = resolve(Resolution)
    ) {
        super();
    }

    public connectedCallback(): void {
        super.connectedCallback();

        this.addEventListener("click", (e: Event) => this.openDialog(e));
        this.addEventListener("keydown", (e: KeyboardEvent) => handleActivationKey(e, () => this.openDialog(e)));

        this.activationBreakpoint = bootstrapBreakpointByName(this.activeFromBreakpoint);
        this.activate(!this.activationBreakpoint || this.resolution.downTo(this.activationBreakpoint));
        if (this.activationBreakpoint) {
            this.resolution.onBootstrapBreakpointChange(breakpoint => {
                this.activate(breakpoint.isDownTo(this.activationBreakpoint!));
            });
        }
    }

    private openDialog(e: Event): void {
        if (clickEventAlreadyHandledByChild(e, this)) {
            return;
        }
        this.dialogs.open(this.dialogId);
    }

    private activate(value: boolean): void {
        this.active = value;
        if (this.active) {
            this.classList.remove("inactive");
        } else {
            this.classList.add("inactive");
        }
    }
}